import React from "react";
import { Button, Modal, ButtonToolbar } from "rsuite";

const FilterSidePanel = ({
  panelOpened,
  onCloseHandler,
  applyFilterHandler,
  onOpenHandler,
  clearFiltersHandler,
  children,
}) => {

  return (
    <Modal
      onOpen={onOpenHandler}
      open={panelOpened}
      className={"filter-content"}
      onClose={onCloseHandler}>

      <Modal.Header>
        <Modal.Title><strong>Filters</strong></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {children}
      </Modal.Body>

      <Modal.Footer>
        <ButtonToolbar>
          <Button appearance="ghost" size="lg" className="filter-btn btn-cancel" onClick={clearFiltersHandler}>Clear Filters</Button>
          <Button appearance="primary" size="lg" className="filter-btn btn-save" onClick={applyFilterHandler}>Apply Filters</Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterSidePanel;
